import { create } from "zustand";

export const useSyncLoaderStore = create((set) => ({
  isLoading: false,
  setIsLoading: (isLoading) => set({ isLoading }),
}));
